<template>
    <component :is="component" v-if="component" :historyData="historyData" :paginationData="paginationData"></component>
</template>

<script>
export default {
    name: "ItemListHistoryLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        listLayout: '',
        historyData:{default: () => []},
        paginationData: {default: {page: 1, size: 10, total: 0}},
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/item/list/ItemListDefaultLayout')
                })
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.listLayout) {
                return null
            }
            return () => import(`@/template/item/list/${this.listLayout}`)
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
